function parseValue(value) {
    if ('false' === value) return false;
    if ('true' === value) return true;
    if (!Number.isNaN(Number(value))) return Number(value);
    return decodeURIComponent(value);
}
function parseURLSearch(searchQuery) {
    if (!searchQuery) return {};
    const result = {};
    for (const [key, value] of new URLSearchParams(searchQuery).entries())if (void 0 === result[key]) result[key] = parseValue(value);
    return result;
}
export { parseURLSearch };
